import { useQuery } from "react-query";
import { getActiveTempReport } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetActiveTempReport = () => {
  return useQuery("GetActiveTempReport", getActiveTempReport, {
    refetchOnWindowFocus: false,
  });
};
export default useGetActiveTempReport;
